<template>
  <div>
    <!--  Title to be customable in the future but hard code for now -->
    <h2 v-if='!showThanksResponse' class="mb-4" >Interest in Microba's Soup Study</h2>
    <h2 v-else class="mb-4">Your response has been submitted</h2>
    <div v-if='!showThanksResponse' class="mt-4">
      <!-- To be customable in the future but hard code for now -->      
      Please express your interest in Microba's soup study by completing the below form.
      <br>
      You will need to validate the email provided by checking your email inbox and following the instructions sent to you.
    </div>
    <div v-else class="mt-4">
      <p class="h5">Please validate the email provided by checking your email inbox and following the 
      instructions provided within the email.<br> You may need to check your spam or junk folders.</p>
    </div>
    <div v-if='!showThanksResponse' class="mt-4">
      <h3>Personal Details</h3>
      <div class="row">
        <div class="form-group col col-md-6">
          <b-form-input
            type="text"
            v-model="firstName"
            required
            autocomplete="given-name"
            v-validate="'required'"
            maxlength="25"
            name="First name"
            :state="errors.has('First name') ? false : null"
            placeholder="First name"
          ></b-form-input>
          <div
            class="invalid-feedback"
            v-show="errors.has('First name')"
          >{{ errors.first('First name') }}</div>
        </div>

        <div class="form-group col col-md-6">
          <b-form-input
            type="text"
            v-model="lastName"
            autocomplete="family-name"
            required
            v-validate="'required'"
            maxlength="25"
            name="Last name"
            :state="errors.has('Last name') ? false : null"
            placeholder="Last name"
          ></b-form-input>
          <div
            class="invalid-feedback"
            v-show="errors.has('Last name')"
          >{{ errors.first('Last name') }}</div>
        </div>

        <div class="form-group col-md-6">
          <b-form-input
            type="email"
            v-model="email"
            v-validate="'required|email'"
            autocomplete="email"
            maxlength="100"
            name="Email"
            :state="errors.has('Email') ? false : null"
            required
            placeholder="Enter email"
          ></b-form-input>
          <div class="invalid-feedback" v-show="errors.has('Email')">{{ errors.first('Email') }}</div>
        </div>

        <div class="form-group col-md-6">
          <vue-tel-input
            v-model="phoneNumber"
            v-bind="phoneProps"
            v-on:onInput="checkPhoneNumberValidity"
            v-on:validate="checkPhoneNumberValidity"
            v-validate="`isValidPhoneNumber:${isPhoneValid}`"
            :class="{ 'is-invalid' : errors.has('Phone')}"
            name="Phone"
          ></vue-tel-input>
          <div class="invalid-feedback" v-show="errors.has('Phone')">{{ errors.first('Phone') }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <btVueButton
          v-if='!showThanksResponse'
          btnClass="btn btn-primary btn-dynamic"
          :actionInProgress.sync="actionInProgress"
          v-on:clicked="validate"
          :btnFinalState="finalState"
        >
        <template #inProgress>
          <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
        </template>
        </btVueButton>
      </div>
    </div>
  </div>
</template>

<script>
import { Validator } from 'vee-validate'
import btVueButton from 'bt-vue-button'
import {TelephoneConfiguration} from '@/model/telephoneConfiguration'
import installValidatorRules from '@/model/validatorRules'

installValidatorRules(Validator)

export default {
  name: 'EOI',
  props: {
    showThanksResponse: {
      type: Boolean,
      default: null
    }
  },
  components: {
    btVueButton
  },
  data () {
    return {
      firstName: null,
      lastName: null,
      email: null,
      phoneNumber: null,
      actionInProgress: null,
      phoneProps: new TelephoneConfiguration({required: false}),
      finalState: null,
      isPhoneValid: null
    }
  },
  methods: {
    checkPhoneNumberValidity (payload) {
      this.isPhoneValid = payload.isValid
      this.phoneNumber = this.isPhoneValid ? payload.number.e164 : payload.number.input
    },
    validate () {
      let payload = {
        'firstName': this.firstName,
        'lastName': this.lastName,
        'email': this.email,
        'phoneNumber': this.phoneNumber,
        'sendEmail': 1
      }
      setTimeout(() => {
        this.actionInProgress = false
      }, 1000)
      this.$validator.validateAll().then(() => {
        if (this.errors.any()) {
          return
        }
        this.finalState = 'success'
        this.$emit('saveRecruimentEOI', payload)
        this.finalState = null
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/EOI.vue